import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ChapterBarComponent } from './chapter-bar/chapter-bar.component';
import { UsefulInfoComponent } from './useful-info/useful-info.component';
import { BackToTopComponent } from './back-to-top/back-to-top.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { IconBoxComponent } from './icon-box/icon-box.component';
import { RibbonComponent } from './ribbon/ribbon.component';
import { ServerErrorComponent } from '../modals/server-error/server-error.component';
import { FormatterModule } from '../directives/formatter/formatter.module';
import { NameformatterDirective } from '../directives/nameformatter.directive';
import { FocusNextInputDirective } from '../directives/focus-next-input.directive';
import { TrimDirective } from '../directives/trim.directive';
import { GsuiteFooterComponent } from './gsuite-footer/gsuite-footer.component';
import { StepperComponent } from './stepper/stepper.component';
import { LzTooltipComponent } from './lz-tooltip/lz-tooltip.component';
import {OrderConfirmationComponent} from './order-confirmation/order-confirmation.component';
import { MicroCopyComponent } from './micro-copy/micro-copy.component';

@NgModule({
  imports : [
    CommonModule,
    RouterModule,
    FormatterModule,
  ],
  declarations : [
    ChapterBarComponent,
    UsefulInfoComponent,
    BackToTopComponent,
    SpinnerComponent,
    IconBoxComponent,
    RibbonComponent,
    ServerErrorComponent,
    GsuiteFooterComponent,
    StepperComponent,
    LzTooltipComponent,
    OrderConfirmationComponent,
    MicroCopyComponent,
  ],
  entryComponents : [
    ServerErrorComponent,
  ],
  exports : [
    CommonModule,
    RouterModule,
    ChapterBarComponent,
    UsefulInfoComponent,
    BackToTopComponent,
    SpinnerComponent,
    IconBoxComponent,
    RibbonComponent,
    ServerErrorComponent,
    GsuiteFooterComponent,
    StepperComponent,
    MicroCopyComponent,
    NameformatterDirective,
    TrimDirective,
    FocusNextInputDirective,
    LzTooltipComponent,
    OrderConfirmationComponent,
  ],
  schemas : [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class SharedComponentsModule {
}
